import { Tooltip } from "components/common";
import { truncateText } from "utils/reports";

const TruncatedText = (props) => {
  const { text = "-", limit = 15 } = props;
  return (
    <Tooltip placement="top" title={text?.length > limit && text}>
      {truncateText(text, limit)}
    </Tooltip>
  );
};

export default TruncatedText;